import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {debounceTime, first, tap} from "rxjs/operators";
import {WebsiteService} from "../../../../../website.service";
import {DbValidators} from "../../../../../../shared/validators/DbValidators";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
@Component({
    selector: 'db-ai-builder-create-page-builder',
    templateUrl: './ai-builder-create-page-builder.component.html',
    styleUrls: ['./ai-builder-create-page-builder.component.scss'],
    standalone: false
})
export class AiBuilderCreatePageBuilderComponent implements OnInit {
  @Input() hideBackButton?: boolean;
  @Input() websiteId?: number;
  @Input() demoUser?: boolean;
  @Output() showUpgradePopup: EventEmitter<any> = new EventEmitter<string>();
  @Output() onBack: EventEmitter<void> = new EventEmitter<void>();
  @Output() onRecreate: EventEmitter<{ title: string, url: string }> = new EventEmitter<{ title: string, url: string }>();

  public builderForm: FormGroup = new FormGroup({
    title: new FormControl('', [Validators.required, DbValidators.trimStart]),
    url: new FormControl('', [Validators.required, DbValidators.trimStart , Validators.pattern('https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,15}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)')]),
  });
  public urlChecking = false;
  public isMobile = window.innerWidth <= 991;

  constructor(
    private _websiteService: WebsiteService,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {
    this._handleUrlChange();
  }

  public _handleUrlChange(): void {
    this.builderForm.get('url').valueChanges
      .pipe(
        tap(() => { this.urlChecking = this.builderForm.get('url').valid; }),
        debounceTime(500),
      )
      .subscribe(() => this._checkUrl());
  }

  private _checkUrl(): void {
    if (this.builderForm.get('url').invalid) return;
    this._websiteService.checkUrl(this.builderForm.get('url').value)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.urlChecking = false;
        this.builderForm.get('url').markAsTouched();
        if (response && (!response.success || !response.data.url_is_valid)) {
          this.builderForm.get('url').setErrors({invalidUrl: 'This site can’t be reached. please change URL.'});
        }
      });
  }

  public recreate(): void {
    if (this.builderForm.invalid) return;
    if (this.demoUser) return this.showUpgradePopup.emit('AI');
    this.onRecreate.emit(this.builderForm.value);
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Create a page with AI',
      eventLabel: 'AI Builder',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
